import { ACTION } from '@talos/kyoko';

import { useFeatureFlag } from './useFeatureFlag';
import { useRoleAuth } from './useRoleAuth';

/**
 * Returns access state for the Customer Asset Transactions view.
 *
 * Access requires the user to have dealer view permission and both related menu/page feature flags enabled.
 *
 * Customer Asset Transactions blotter is accessible
 * in a lot of places so this consolidates the gating.
 */
export function useCustomerAssetTransactionsAccess() {
  const { viewDealerAdminAndBuyingPowerMenuItems, viewDealerMarginPages } = useFeatureFlag();
  const { isAuthorized } = useRoleAuth();

  return {
    canViewCustomerAssetTransactions:
      isAuthorized(ACTION.VIEW_DEALER) && viewDealerAdminAndBuyingPowerMenuItems && viewDealerMarginPages,
  };
}
